import {ActionTree} from 'vuex'
import {AxiosError, AxiosResponse} from "axios";
// @ts-ignore
import Api from "@/api.js";
import IDPVariableSettings from "@/modules/DynamicProfiling/ts/IDPVariableSettings";

export const actions: ActionTree<any, any> = {

    getDataVariableUsageStats: ({state, getters, commit, dispatch}, filter) => {

        return new Promise((resolve, reject) => {

            let params = [];

            if (filter && filter.period) {
                params.push('period=' + filter.period);
            }

            let url = '/sub-panel/' + filter.subPanelId + '/dynamic-profiling';

            if (params.length > 0) {
                url += '?' + params.join('&');
            }

            Api.get(url)
                .then((response: AxiosResponse) => {
                    commit('setDataVariableUsageStats', response.data.data.hydration_stats);
                    commit('setDynamicProfilingStats', response.data.data.dynamic_profiling_stats);
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    saveDPVariableSettings: ({state, getters, commit, dispatch}, subPanelId) => {

        return new Promise((resolve, reject) => {

            const data = state.dpVariables
                .filter((variable: IDPVariableSettings) => variable.enabled !== null);

            Api.post('/sub-panel/' + subPanelId + '/dynamic-profiling', {settings: data})

                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },
};
